import { RootState } from 'store';

export const TaskClassificationsLookupState = (state: RootState) => state.lookups.taskClassifications;

export const selectTaskClassifications = (state: RootState) => TaskClassificationsLookupState(state).rows;
